import "./FlowButton.scss";

function FlowButton({
  children,
  onClick,
  variant = "default",
  icon,
  disabled = false,
  className = "",
  palette = false,
  paletteColor,
  showChevron = false,
  isExpanded = false,
}) {
  const variantClass = palette
    ? "palette"
    : variant === "update"
      ? "update"
      : variant === "danger"
        ? "danger"
        : "default";

  const buttonStyle =
    palette && paletteColor ? { backgroundColor: paletteColor } : {};

  return (
    <button
      className={`flow-button ${variantClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={buttonStyle}
    >
      <span className="flow-button-text">{children}</span>
      {icon && (
        <span className="material-symbols-outlined flow-button-icon">
          {icon}
        </span>
      )}
      {palette && showChevron && (
        <span className="material-symbols-outlined flow-button-chevron">
          {isExpanded ? "expand_less" : "expand_more"}
        </span>
      )}
    </button>
  );
}

export default FlowButton;
